import styled from 'styled-components';
import { BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const ButtonPDF = styled('div')`
	position: relative;
	cursor: pointer;
	padding: 5px;
	border-radius: 6px;

	span {
		font-size: 12px;
		color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	}

	svg {
		width: 15px;
		height: 15px;
		margin-right: 5px;
		position: relative;
		top: 3px;
		fill: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	}

	&:hover {
		background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 10)}
	}
`;


export {
	ButtonPDF,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/ButtonPDF/styles.ts